var _circle, _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 214,
    viewBox: "0 0 214 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 106.5,
    r: 55.5,
    fill: "#4F4F4F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_62_8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 107,
    r: 75,
    fill: "#767676",
    fillOpacity: 0.34
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.335 98.6229H95.0854C94.0771 98.6229 93.2521 97.7979 93.2521 96.7896C93.2521 95.7812 94.0771 94.9562 95.0854 94.9562H114.335C115.344 94.9562 116.169 95.7812 116.169 96.7896C116.169 97.7979 115.344 98.6229 114.335 98.6229ZM103.106 108.706H94.8563C93.8479 108.706 93.0229 107.881 93.0229 106.873C93.0229 105.865 93.8479 105.04 94.8563 105.04H103.106C104.115 105.04 104.94 105.865 104.94 106.873C104.94 107.881 104.115 108.706 103.106 108.706ZM99.4396 118.79H94.8563C93.8479 118.79 93.0229 117.965 93.0229 116.956C93.0229 115.948 93.8479 115.123 94.8563 115.123H99.4396C100.448 115.123 101.273 115.948 101.273 116.956C101.273 117.965 100.448 118.79 99.4396 118.79ZM118.667 103.917C111.081 103.917 104.917 110.081 104.917 117.667C104.917 125.252 111.081 131.417 118.667 131.417C126.252 131.417 132.417 125.252 132.417 117.667C132.417 110.081 126.252 103.917 118.667 103.917ZM118.667 127.75C113.098 127.75 108.583 123.235 108.583 117.667C108.583 112.098 113.098 107.583 118.667 107.583C124.235 107.583 128.75 112.098 128.75 117.667C128.75 123.235 124.235 127.75 118.667 127.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.667 122.204C117.956 122.915 116.787 122.915 116.077 122.204L112.181 118.308C111.471 117.598 111.471 116.429 112.181 115.719C112.892 115.008 114.06 115.008 114.771 115.719L118.667 119.615C119.377 120.325 119.377 121.494 118.667 122.204Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.152 115.719L118.667 122.204C117.956 122.915 116.788 122.915 116.077 122.204C115.367 121.494 115.367 120.325 116.077 119.615L122.563 113.129C123.273 112.419 124.442 112.419 125.152 113.129C125.863 113.84 125.863 115.008 125.152 115.719Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.25 124.29H90.3875V89.4563H118.804V100.25C118.804 101.258 119.629 102.083 120.637 102.083C121.646 102.083 122.471 101.258 122.471 100.25V88.5396C122.471 87.0271 121.233 85.7896 119.721 85.7896H89.4708C87.9583 85.7896 86.7208 87.0271 86.7208 88.5396V125.206C86.7208 126.719 87.9583 127.956 89.4708 127.956H101.25C102.258 127.956 103.083 127.131 103.083 126.123C103.083 125.092 102.258 124.29 101.25 124.29Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_62_8",
    x: 0.6,
    y: 0.6,
    width: 212.8,
    height: 212.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.7,
    result: "effect1_foregroundBlur_62_8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT1);
export default __webpack_public_path__ + "static/media/T1.a7a387db948a4a90df529e1b5dc3a8da.svg";
export { ForwardRef as ReactComponent };